import { Component } from 'vue-property-decorator';

import { getLocalizedRoute, routes } from '~/app/core/router/routes';
import { VueComponent } from '~/utils/vue-component';

@Component
export default class extends VueComponent<{}> {
  protected get title(): string {
    return this.$t('app.contactBanner.title').toString();
  }

  protected get subtitle(): string {
    return this.$t('app.contactBanner.subtitle').toString();
  }

  protected get buttonText(): string {
    return this.$t('app.contactBanner.button').toString();
  }

  protected get isMobile(): boolean {
    return ['xs', 'sm'].indexOf(this.$vuetify.breakpoint.name.toString()) > -1;
  }

  public render() {
    return (
      <v-container class='py-3 px-3 text-center'>
        <v-row justify='center' no-gutters>
          <v-col cols='12' md='9'>
            <p
              class={`accent--text font-weight-bold mb-1 ${
                this.isMobile ? 'title' : 'headline'
              }`}
            >
              {this.title}
            </p>
            <p class='grey--text mb-3'>{this.subtitle}</p>
            <v-btn
              to={getLocalizedRoute(routes.contact, this.$router)}
              class='accent contrast--text'
              large={!this.isMobile}
              depressed
            >
              {this.buttonText}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    );
  }
}
